"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const autocomplete_menu_style_1 = require("../../components/autocomplete.menu/autocomplete.menu.style");
const menu_item_style_1 = require("../../components/menu/menu.item.style");
const theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-TagInput',
    filterMatch: 'c-TagInput__match',
    link: 'c-TagInput__link',
    title: 'c-TagInput__title',
    date: 'c-TagInput__date',
    linkEditable: 'c-TagInput__link--editable',
};
exports.Style = {
    [exports.CSS.container]: {
        flex: '1 1',
        display: 'flex',
        position: 'relative',
        [`& .${autocomplete_menu_style_1.CSS.container}`]: {
            position: 'absolute',
            top: '100%',
            left: '0',
        },
        [`& .${autocomplete_menu_style_1.CSS.container} .${menu_item_style_1.CSS.item}`]: {
            overflow: 'hidden',
            display: ' inline-block',
            'text-overflow': 'ellipsis',
            'white-space': 'nowrap',
            'text-align': 'left',
        },
    },
    [exports.CSS.date]: {
        color: theme_1.DefaultTheme.font.color.disabled,
        'line-height': theme_1.DefaultTheme.space(4),
        'font-size': '90%',
    },
    [exports.CSS.title]: {
        'line-height': theme_1.DefaultTheme.space(4),
    },
    [exports.CSS.filterMatch]: {
        fontWeight: theme_1.DefaultTheme.font.weight.bold,
    },
    [exports.CSS.link]: {
        padding: `0 ${theme_1.DefaultTheme.space(1)}`,
        flex: '1 1',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        cursor: 'pointer',
    },
    [exports.CSS.linkEditable]: {
        extend: exports.CSS.link,
        width: '100%',
        lineHeight: theme_1.DefaultTheme.space(6),
        fontFamily: theme_1.DefaultTheme.font.familyCondensed,
        fontSize: theme_1.DefaultTheme.font.size,
        background: 'transparent',
        outline: 'none',
        border: 'none',
        borderBottom: `2px solid ${theme_1.DefaultTheme.color.primary}`,
        cursor: 'text',
    },
};
//# sourceMappingURL=tag.name.input.style.js.map